import React, { useState } from "react";
import HeaderPage from "./HeaderPage";
import useRecorder from "./utils/useRecorder";
import { CirclesWithBar } from "react-loader-spinner";
import {
  ArrowClockwise,
  Microphone,
  Pause,
  Record,
  Stop,
} from "phosphor-react";
import watermarkImageUrl from "../assets/images/tubewatermark.png";
import axios from "axios";
import requestImage from "./utils/ser";
import CanvasComponent from "./CanvasComponent";
const LanguageList = {
  "en-IN": "English",
  "hi-IN": "हिंदी [Hindi]",
  "te-IN": "తెలుగు [Telugu]",
  "ta-IN": "தமிழ் [Tamil]",
  "kn-IN": "ಕನ್ನಡ [Kannada]",
  "ml-IN": "മലയാളം [Malayalam]",
  "mr-IN": "मराठी [Marathi]",
  "gu-IN": "ગુજરાતી [Gujarati]",
  "bn-IN": "বাঙ্গালি [Bengali]",
  "ur-IN": "اردو [Urdu]",
  // "ru-RU": "Русский [Russian]",
  // "es-ES": "Español [Spanish]",
  // "fr-BE": "Français [French]",
  // "zh-TW": "中国人 [Chinese]",
  // "ar-AE": "عربي [Arabic]",
  // "pt-PT": "Português [Portuguese]",
  // "su-ID": "basa Sunda [Sundanese]",
  // "de-AT": "Deutsch [German]",
  // "ja-JP": "日本 [Japanese]",
  // "ko-KR": "한국인 [Korean]",
  // "it-IT": "Italiano [Italian]",
  // "tr-TR": "Türkçe [Turkish]",
  // "ms-MY": "Melayu [Malay]",
};
function TextToImage() {
  let [
    audioURL,
    isRecording,
    startRecording,
    stopRecording,
    pause,
    setPause,
    resume,
    setResume,
    setIsRecording,
    setReset,
  ] = useRecorder();
  const [loading, setLoading] = useState(false);
  const [isDivVisible, setDivVisibility] = useState(false);
  const [sourceLanguage, setSourceLanguage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [Text, setText] = useState("");
  const [TransText, setTransText] = useState("");
  const [imageSrc, setImageSrc] = useState("");
  function trimSpecialCharacters(inputString) {
    // Use regular expression to remove all non-alphanumeric characters
    return inputString.replace(/[^a-zA-Z0-9 ]/g, '');
  }
  let unwantedWords = ["bad", "sample", "narendra", "modi","prime","minister"];
  function censorString(inputString) {
    // Use a regular expression to replace unwanted words with asterisks
    let NewinputString= inputString.replace(/[^a-zA-Z0-9 ]/g, '');
    unwantedWords.forEach(word => {
      const regex = new RegExp(`\\b${word}\\b`, 'gi');
      if (regex.test(inputString)) {
        setText("")
        alert("prompt not allowed")
        
        
        NewinputString = ""
        return ""
        
      }
     
    });
  
    return NewinputString;
  }
  React.useEffect(() => {
    const fetchText = async () => {
      let fileName = `aud.wav`;
      let fd = new FormData();
      const output = await axios({
        method: "get",
        url: audioURL, // blob url eg. blob:http://127.0.0.1:8000/e89c5d87-a634-4540-974c-30dc476825cc
        responseType: "blob",
      });
      const selectedLang = sourceLanguage;
      let files = new File([output.data], fileName, { type: "audio/wav" });
      console.log(files);
      fd.append("file", files);
      fd.append("language", selectedLang);
      let config = {
        "Content-Type": "multipart/form-data",
      };
      //   setLoading(true);
      axios
        .post("https://voiceapi.aicte-india.org/voice-to-text", fd)
        .then(async (res) => {
          setLoading(false);
          const textResponse = res.data;
          if (
            textResponse &&
            textResponse.data !== "" &&
            textResponse.data !== undefined
          ) {
            
            setText(textResponse.data.replace(/\.$/, ''));
          }
        })
        .catch((errr) => {
          setLoading(false);
          console.log("Invalid query!");
        });
    };
    if (audioURL !== undefined) {
      fetchText();
    }
  }, [audioURL]);

  const generateImage = async () => {
    let prompt = "";
    if (Text == "") {
     
      alert("Please enter a prompt");
      return;
    }
    let fd = new FormData();
    fd.append("text", Text);
    fd.append("outputLang", "en-IN");

    let payload = {text: Text, outputLang: "en-IN"}

    axios.post("https://voiceapi.aicte-india.org/text-to-text",payload).then(async (res) => {
    
    setTransText(res.data.data)
    console.log(TransText)
    let censorStrin = censorString(res.data.data);
    if (censorStrin == "") {
      return;
    }
    const url =
    "https://bharattube.aicte-india.org/api/generate-image/generate-image";

  let formData = new FormData();
  formData.append("prompt", censorStrin);
  try {
    setLoading(true);
    setImageSrc("")
    const response = await axios.post(url, formData);
    console.log(response.data.base64);
    setImageSrc(response.data.base64);
    setLoading(false);
    // const response = await axios.request(config)
    // .then((response) => {
    //   console.log(JSON.stringify(response.data));}).catch((err)=>{console.log(err)});

    // console.log(response);
  } catch (error) {
    console.error(error);
    setLoading(false);
    // Handle errors here
  }
    })
 
  };

  return (
    <>
      <HeaderPage />
      <section className="logoSec youtubeSessionSec">
        <div className="sessionDiv">
          <div className="container">
            <div
              className="cntnrLogo"
              style={{
                display: "flex",
                alignContent: "flex-start",
                justifyContent: "center",
              }}
            >
              {/* <img src={bharat_voice} style={{ height: "14vh" }} alt="logo" /> */}
              {/* <img
                className="madeInBhrt"
                src={madeinBharat}
                style={{ height: "10vh" }}
                alt="logo"
              /> */}
            </div>
            <div className="videoSldrCnt">
              <h2>Text to Image 22 AI</h2>
  <p>Create experiences, pictorial wonder in Bharatiya languages.</p>
       
            </div>

            <div className="realtimevideoCnt">
              <div className="inputGroup">
                <select onChange={(e) => setSourceLanguage(e.target.value)}>
                  <option value="" disabled selected>
                    Select a Source language
                  </option>
                  {Object.keys(LanguageList).map((key) => (
                    <option key={key} value={key}>
                      {LanguageList[key]}
                    </option>
                  ))}
                </select>{" "}
                {sourceLanguage ? (
                  <>
                  <div className="inputfrom">
                    <input
                    type="text"
                    placeholder="Enter Your Prompt"
                    value={Text}
                    onChange={(e) => setText(e.target.value)}
                  />
                  
                  {isRecording ? (
                  <React.Fragment>
                    <button
                      className="stopbutton button orange"
                      onClick={stopRecording}
                      disabled={!isRecording}
                    >
                      <Stop size={20} weight="fill" />
                    </button>
                    {pause != false ? (
                      <>
                        <button
                          className="startbutton button green"
                          onClick={() => {
                            setPause(false);
                            setResume(true);
                          }}
                        >
                          <Record size={20} weight="fill" />
                        </button>
                        <button
                          className="stopbutton button orange"
                          onClick={() => {
                            setText("");
                          }}
                          disabled={!isRecording}
                        >
                          <ArrowClockwise size={20} weight="bold" />
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          className="stopbutton button orange"
                          onClick={() => {
                            setPause(true);
                          }}
                        >
                          <Pause size={20} weight="fill" />
                        </button>
                        {Text ? (
                          <button
                            className="startbutton button orange"
                            onClick={() => {
                              setText("");
                            }}
                            disabled={!isRecording}
                          >
                            <ArrowClockwise size={20} />
                          </button>
                        ) : (
                          ""
                        )}
                      </>
                    )}
                  </React.Fragment>
                ) : (
                  <button
                    className="startbutton button green"
                    onClick={(e) => {
                      startRecording();
                      setText("");
                    }}
                    disabled={isRecording}
                  >
                    <Microphone size={20} weight="fill" />
                  </button>
                )}
                  
               
               
                </div>
                <button onClick={generateImage} className="button orange">Generate image</button>
                </> ) : null}
                {/* {loading && <p>Loading...</p>} */}
                {errorMessage && <p>Error: {errorMessage}</p>}
              </div>
              {imageSrc && (
                <div className="inputGroup">
                  {/* <img
                    width={"100%"}
                    src={`data:image/png;base64,${imageSrc}`}
                    alt="Generated Image"
                  /> */}
                      <div >
      {/* <img src={`data:image/png;base64,${imageSrc}`} style={{width:'100%'}} alt="Base64 Image" /> */}
<CanvasComponent base64img={imageSrc}/>
      {/* Watermark */}
      {/* <div
        style={{
          position: 'relative',
          bottom: '25px',
          left: '88px', // Adjust the positioning as needed
          color: 'white', // Adjust the color of the watermark text
          fontSize: '16px', // Adjust the font size of the watermark text
          fontWeight: 'bold', // Adjust the font weight of the watermark text
        }}
      >
        AI Generated Image from ANUVADINI
      </div> */}
    </div>
                       {/* <img
                    src={watermarkImageUrl}
                    alt="Watermark"
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      opacity: 0.8,
                      height: "6vw",
                      pointerEvents: "none", // To allow interaction with video
                    }}
                  /> */}
                </div>
              )}
              {loading && (
                <div className="loading-overlay">
                  <div className="load">
                    <CirclesWithBar
                      height="100"
                      width="100"
                      color="#4fa94d"
                      outerCircleColor="#4fa94d"
                      innerCircleColor="#4fa94d"
                      barColor="#4fa94d"
                      ariaLabel="circles-with-bar-loading"
                      wrapperStyle={{}}
                      wrapperClass=""
                      visible={true}
                    />
                    <h4>Loading...</h4>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default TextToImage;
